import { v4 as uid } from 'uuid';

import { SignupState } from '../store/signup/types';
import { getAxiosClient } from '@givelify/utils';
import { webConfig } from 'webConfig';

const endPoint = '/signup/progress';
const uuidHolderText = 'uuid';

export const saveProgress = (signup: Partial<SignupState>): void => {
    const axiosClient = getAxiosClient({ baseURL: webConfig.baseUrl });
    axiosClient(endPoint, {
        method: 'POST',
        data: signup,
    });
};

export const generatedUUID = (): string => {
    const uuid = localStorage?.getItem(uuidHolderText);
    if (uuid) {
        return uuid;
    }
    const newUuid = uid();
    localStorage.setItem(uuidHolderText, newUuid);
    return newUuid;
};

export const removeUUID = (): void => {
    localStorage?.removeItem(uuidHolderText);
};
